<template>
  <b-card title="GSM">
    <table class="table">
      <tr>
        <td ><strong>Operator</strong></td>
        <td class="text-right">{{ operatorValue }}</td>
      </tr>
      <tr>
        <td><strong>Connection Type</strong></td>
        <td class="text-right u-access-tech">{{ accessTechValue }}</td>
      </tr>
      <tr>
        <td ><strong>Registration State</strong></td>
        <td class="text-right u-registration-state">{{ registrationStateValue }}</td>
      </tr>
      <tr>
        <td ><strong>Signal Strength</strong></td>
        <td class="text-right">{{ signalValue }}</td>
      </tr>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp"/>
  </b-card>
</template>

<script>

import CardTimestampFooter from '@/components/Device/CardTimestampFooter/CardTimestampFooter';

export default {
  name: 'GSMCard',
  components: {CardTimestampFooter},
  props: {
    gsm: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    operatorValue() {
        return this.gsm.operator !== null ? this.gsm.operator : 'UNKNOWN';
    },
    registrationStateValue() {
       return this.gsm.registration_state !== null ? this.gsm.registration_state : 'UNKNOWN';
    },
    signalValue() {
        if (this.gsm.signal === null || this.gsm.signal === undefined) return 'UNKNOWN';
        return `${this.gsm.signal}%`;
    },
    accessTechValue() {
       return this.gsm.access_tech !== null ? this.gsm.access_tech : 'UNKNOWN';
    },
    timestamp(){
      return this.gsm.timestamp !== null ? this.gsm.timestamp : null;
    }
  }
};
</script>


<style src="./GSMCard.scss" lang="scss" scoped/>
